import { Table, TableBody } from "@mui/material";
import { AccountBalance as BankIcon } from "@mui/icons-material";
import type {
  VendorProfileDocument,
  VendorProfileFacility,
  VendorType,
} from "../types";
import { SectionCard } from "../components/SectionCard";
import { FieldRow } from "../components/FieldRow";
import { AttachmentDisplay } from "../components/AttachmentDisplay";
import { maskAccountNumber } from "../utils/masking";
import { formatText } from "../utils/format";
import { findDocument } from "../utils/documentLookup";

type Props = {
  profile: VendorProfileFacility;
  vendorType: VendorType;
  documents: VendorProfileDocument[] | undefined;
};

export function BankingSection({ profile, vendorType, documents }: Props) {
  const cancelledCheque = findDocument(
    documents,
    "facility",
    profile.id,
    "Bank_Verification",
  );
  const bankLetter = findDocument(
    documents,
    "facility",
    profile.id,
    "Bank_Details_Letter",
  );
  const isInternational = vendorType === "International";
  return (
    <SectionCard icon={<BankIcon fontSize="small" />} title="Bank Details">
      <Table size="small">
        <TableBody>
          <FieldRow
            label="Account Number"
            value={maskAccountNumber(profile.account_number)}
          />
          <FieldRow label="IFSC Code" value={formatText(profile.ifsc_code)} />
          <FieldRow label="Bank Name" value={formatText(profile.bank_name)} />
          <FieldRow label="Bank Branch" value={formatText(profile.branch_name)} />
          <FieldRow
            label="Account Holder Name"
            value={formatText(profile.account_name)}
          />
          <FieldRow
            label="Account Type"
            value={formatText(profile.account_type)}
          />
          <FieldRow
            label="Cancelled Cheque"
            value={<AttachmentDisplay document={cancelledCheque} />}
          />
          {isInternational && (
            <FieldRow
              label="Bank Details Letter"
              value={<AttachmentDisplay document={bankLetter} />}
            />
          )}
        </TableBody>
      </Table>
    </SectionCard>
  );
}

export default BankingSection;
